import {
  SET_LOGIN_STATE,
  SET_LOGIN_ERROR,
  SET_CURRENT_DIRECTORY,
  SET_CURRENT_DIRECTORY_CONTENTS,
  SET_DIRECTORY_STRUCTURE,
  SET_OBJECT_TYPE,
  SET_DIRECTORY_PERMISSIONS,
  SET_RELATED_FILES
} from './mutationTypes';

const setLoginState = (state, { loggedIn }) => {
  state.loggedIn = loggedIn;
};

const setLoginError = (state, { error }) => {
  state.loginError = error;
};

const setCurrentDirectory = (state, { currentDirectory }) => {
  state.currentDirectory = currentDirectory;
};

const setObjectType = (state, { objectType }) => {
  state.objectType = objectType;
};

const setDirectoryStructure = (state, { directoryStructure }) => {
  state.directoryStructure = directoryStructure;
};

const setDirectoryPermissions = (state, { directoryPermissions }) => {
  state.directoryPermissions = directoryPermissions;
};

const setDirectoryContents = (state, { directoryContents }) => {
  state.directoryFiles = directoryContents;
};

const setRelatedFiles = (state, { relatedFiles }) => {
  state.relatedFiles = relatedFiles;
};

export default {
  [SET_LOGIN_STATE]: setLoginState,
  [SET_LOGIN_ERROR]: setLoginError,
  [SET_CURRENT_DIRECTORY]: setCurrentDirectory,
  [SET_OBJECT_TYPE]: setObjectType,
  [SET_DIRECTORY_STRUCTURE]: setDirectoryStructure,
  [SET_DIRECTORY_PERMISSIONS]: setDirectoryPermissions,
  [SET_CURRENT_DIRECTORY_CONTENTS]: setDirectoryContents,
  [SET_RELATED_FILES]: setRelatedFiles
};
